/**
 * Compte à rebours des opérations commerciales.
 *
 * Le HTML ne porte que l'horodatage de FIN ; tout le calcul se fait ici, dans le
 * navigateur. C'est la seule façon correcte de procéder : Shopify met les pages en
 * cache, donc un décompte rendu en Liquid se figerait et afficherait une durée
 * fausse pendant des heures. Le serveur ne décide que d'une chose — afficher ou non
 * le bloc, selon que la date est future ou passée.
 *
 * Le script n'est chargé que lorsqu'un compte à rebours est réellement rendu
 * (cf `snippets/sni-promo.liquid`). Coût : un intervalle d'une seconde qui met à
 * jour quatre nœuds de texte, et qui s'arrête de lui-même quand tout est expiré.
 */
(() => {
  const blocs = document.querySelectorAll('[data-sni-compte]');
  if (!blocs.length) return;

  let minuteur = null;
  const deuxChiffres = (n) => String(n).padStart(2, '0');

  const rafraichir = () => {
    let actifs = 0;

    blocs.forEach((bloc) => {
      const fin = Date.parse(bloc.dataset.fin);
      if (Number.isNaN(fin)) return;

      let reste = Math.floor((fin - Date.now()) / 1000);
      if (reste <= 0) {
        // Expiré : on masque le décompte, PAS l'encart qui le contient. Le texte
        // promo reste sous la responsabilité du merchandising, et c'est aussi ce
        // que fait le serveur au prochain rendu — les deux restent cohérents.
        bloc.hidden = true;
        return;
      }

      actifs += 1;
      const jours = Math.floor(reste / 86400);
      reste -= jours * 86400;
      const heures = Math.floor(reste / 3600);
      reste -= heures * 3600;
      const minutes = Math.floor(reste / 60);
      const secondes = reste - minutes * 60;

      const valeurs = {
        j: String(jours),
        h: deuxChiffres(heures),
        m: deuxChiffres(minutes),
        s: deuxChiffres(secondes),
      };

      Object.keys(valeurs).forEach((cle) => {
        const noeud = bloc.querySelector('[data-' + cle + ']');
        // On n'écrit que si la valeur change : les jours et les heures ne bougent
        // presque jamais, inutile de les réécrire chaque seconde.
        if (noeud && noeud.textContent !== valeurs[cle]) noeud.textContent = valeurs[cle];
      });
    });

    if (!actifs && minuteur) {
      clearInterval(minuteur);
      minuteur = null;
    }
  };

  rafraichir();
  if (document.querySelector('[data-sni-compte]:not([hidden])')) {
    minuteur = setInterval(rafraichir, 1000);
  }
})();
